/*
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: zhiqiang.xia@dsicm.com
 * @Date: 2021-07-20 12:11:32
 * @LastEditors: zhiqiang.xia@dsicm.com
 * @LastEditTime: 2021-08-03 12:03:56
 * @FilePath: \新建文件夹 (2)\dsicm-admin-web\src\views\treatment\components\CrossReferenceEntry\api.js
 */

// 对照录入 接口模块
import request from '@/utils/req.js';

//获取检验类别接口
export function getCategoryByCondition(params) {
    return request.post("/admin/standard-category/getCategoryByCondition",params);
}
//根据类别获取项目接口
export function getInspectionList(params) {
    return request.post("/admin/inspection-info/list",params);
}
//模糊查询医院
export function getHospitalList(params) {
    return request.get("/admin/hospital",params);
}
//模糊查询科室
export function getDepartList(params) {
    return request.post("/admin/standard-department/select",params);
}

//西药 获取频率\用法、单位 接口
export function medication_frequency(params) {
    return request.get(`admin/category/${params}/children`,params);
}
//运动类型接口
export function standard_list(params) {
    return request.post("admin/standard-category/list",params);
}
//根据运动类型id 获取运动项目接口
export function movement_list(params) {
    return request.post("admin/movement-info/list",params);
}
//治疗项目模糊查询
export function treatment_list(params) {
    return request.post("/admin/treatment-item/list",params);
}
//对照录入模块 查看单条对照录入
export function apiGetPatientFiles(params) {
    return request.get("/admin/patient-files/detail",params);
}
//对照录入病程关联列下拉框数据
export function api_archives_options(params) {
    return request.get('/admin/archives-event/options', params)
}
//查询其他待对照录入文件
export function api_getOtherFiles(params) {
    return request.post('/admin/patient-files/getOtherFiles', params)
}
//对照录入保存
export function api_getPatientFiles(params) {
    return request.post('/admin/patient-files', params)
}
//修改对照录入文件名字
export function api_patient_files(params) {
    return request.put('/admin/patient-files-item', params)
}

//根据事件ID 获取对照录入信息
export function apiGetPatientById(params) {
    return request.get("/admin/patient-files/getByRefId", params)
}

//管理方案模型   方案配置 药品查询
export function api_getdrug(params) {
    return request.get("/admin/drug/",params);
}

//获取检查项目模糊搜索
export function api_inspection(params) {
    return request.post("/admin/examine-info/list",params);
}

//检查部位模糊搜索
export function api_operate_position(params) {
    return request.get("/admin/category/operate_position/children",params);
}

// 个案使用对照录入保存的就诊地点列表查询
export function getPlaceList(params) {
  return request.post("/admin/case-mgr-place/list", params)
}

//标准科室选择列表
export function getDepartmentList(params) {
  return request.post("/admin/standard-department/select", params)
}


//根据事件id查询事件下关联数据的相关信息
export function getArchivesEventLog(params) {
  return request.get(`/admin/archives-event/getArchivesEventByArchivesId/${params}`)
}


//部位方位模糊搜索
export function api_part_orientation(params) {
  return request.get("/admin/category/part_orientation/children",params);
}

//拍摄方位模糊搜索
export function api_shoot_orientation(params) {
  return request.get("/admin/category/shoot_orientation/children",params);
}

//根据检验名称模糊分页搜索检验详情数据
export function getInspectionInfoPageByName(params) {
  return request.post("/admin/inspection-info/getInspectionInfoPageByName", params)
}

//对照录入文件表列表查询
export function getPatientFilesItemList(params) {
  return request.post("/admin/patient-files-item/list", params)
}
